import { icons } from "src/assets"

export const PROPERTY_HIGHLIGHTS = {
  CONDO: "CONDO",
  APARTMENT: "APARTMENT",
  HOUSEORTOWNHOUSE: "HOUSE_OR_TOWNHOUSE",
  ROOM: "ROOM",
  BASEMENT: "BASEMENT",
  OTHER: "OTHER",
  TOWNHOUSE: "TOWNHOUSE"
}

export const PETS_HIGHLIGHTS = {
  CATS: "CATS",
  DOGS: "DOGS",
  OTHER: "OTHER",
  CATSANDDOGS: "CATS_AND_DOGS",
  NONE: "NONE"
}

export const PARKING_HIGHLIGHTS = {
  ASSIGNED: "ASSIGNED",
  SHARED: "SHARED",
  GARAGE: "GARAGE",
  OTHER: "OTHER",
  NONE: "NONE"
}

export const property_highlights = [
  { name: "Condo", value: PROPERTY_HIGHLIGHTS.CONDO, icon: "/images/building.svg" },
  { name: "Apartment", value: PROPERTY_HIGHLIGHTS.APARTMENT, icon: "/images/building.svg" },
  { name: "House", value: PROPERTY_HIGHLIGHTS.HOUSEORTOWNHOUSE, icon: "/images/house.svg" },
  { name: "Room", value: PROPERTY_HIGHLIGHTS.ROOM, icon: "/images/bed.svg" },
  { name: "Basement", value: PROPERTY_HIGHLIGHTS.BASEMENT, icon: "/images/staircase.svg" },
  { name: "Other", value: PROPERTY_HIGHLIGHTS.OTHER, icon: "/images/boat.svg" },
  { name: "Townhouse", value: PROPERTY_HIGHLIGHTS.TOWNHOUSE, icon: "/images/house.svg" }
]

export const pets_highlights = [
  { name: "Cat", value: PETS_HIGHLIGHTS.CATS, icon: icons.cat },
  { name: "Dog", value: PETS_HIGHLIGHTS.DOGS, icon: icons.dog },
  { name: "Other", value: PETS_HIGHLIGHTS.OTHER, icon: icons.collar }
]
